import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import {FormItemComponentInterface} from '../../../../interface/component';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {IFormItemsControls} from '../../../../interface/form-structure';
import {GlobalObjectService} from '../../../../class/global-obj';
import {HttpFormDataService} from '../../../../services/services';
import {IHttpReturnParam, IHttpSetting} from '../../../../interface/dataset-params';

@Component({
    selector: 'noos-currency',
    templateUrl: './currency.component.html',
    styleUrls: ['./currency.component.scss']
})
@NoosFormTypeService.register('currency')
export class CurrencyComponent implements OnInit, AfterViewInit, FormItemComponentInterface {

    prop: IFormItemsControls;
    setting: IHttpSetting;
    currencyItemData: IHttpReturnParam[] = [];

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();


    mask;

    constructor(private httpService: HttpFormDataService) {
        this.setting = GlobalObjectService.getVar('setting');
    }

    ngOnInit() {
        const setting = GlobalObjectService.getVar('setting');
        if (setting.env.length > 0) {
            if (setting.env[0].currency_dataset_id && setting.env[0].currency_dataset_id > 0) {
                this.httpService.getDatasetParams(this.setting, setting.env[0].currency_dataset_id).subscribe(ret => {
                    if (ret.complete) {
                        this.currencyItemData = ret.data;
                    }
                });
            }

            const dl = parseInt(setting.env[0].decimalLimit.toString(), 0);
            this.mask = createNumberMask({
                allowDecimal: setting.env[0].allowDecimal,
                includeThousandsSeparator: setting.env[0].includeThousandsSeparator,
                prefix: '',
                suffix: '',
                decimalSymbol: setting.env[0].decimalSymbol.toString(),
                thousandsSeparatorSymbol: setting.env[0].thousandsSeparatorSymbol.toString(),
                decimalLimit: dl
            });
        } else {
            const dl = parseInt(this.prop.options.decimalLimit.toString(), 0);
            this.mask = createNumberMask({
                allowDecimal: this.prop.options.allowDecimal,
                includeThousandsSeparator: this.prop.options.includeThousandsSeparator,
                prefix: this.prop.options.inlinePrefix,
                suffix: this.prop.options.inlineSuffix,
                decimalSymbol: this.prop.options.decimalSymbol.toString(),
                thousandsSeparatorSymbol: this.prop.options.thousandsSeparatorSymbol.toString(),
                decimalLimit: dl
            });
        }
    }

    getMask() {
        return {mask: this.mask};
    }


    ngAfterViewInit(): void {
    }

}
